import { Box, Grid, Paper, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { IAccidents } from '../../../services/api/action-plan/EmergencyRegistration';

interface CauseProps {
    value: IAccidents | undefined;
    onChange: (data: IAccidents) => void;
    smDown: boolean;
}

export const Cause = ({ value, onChange, smDown }: CauseProps) => {
    const [data, setData] = useState<IAccidents>({
        art: '',
        data_emissao: '',
        empresa_elaboradora: '',
        responsavel_tecnico: '',
    });

    useEffect(() => {
        if (value) {
            setData(value);
        }
    }, [value]);

    const handleChange = (name: keyof IAccidents, value: string) => {
        const updatedData = { ...data, [name]: value };
        setData(updatedData);
        onChange(updatedData);
    };

    return (
        <Box padding={1} margin={2}>
            <Grid container padding={2} spacing={2}>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        label='Data emissão'
                        value={data.data_emissao}
                        type='date'
                        name='data_emissao'
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        onChange={(e) => handleChange('data_emissao', e.target.value)}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Empresa'
                        value={data.empresa_elaboradora}
                        name='empresa_elaboradora'
                        fullWidth
                        onChange={(e) => handleChange('empresa_elaboradora', e.target.value)}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='ART'
                        value={data.art}
                        name='art'
                        fullWidth
                        onChange={(e) => handleChange('art', e.target.value)}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        InputLabelProps={{ shrink: true }}
                        label='Responsável técnico'
                        value={data.responsavel_tecnico}
                        name='responsavel_tecnico'
                        fullWidth
                        onChange={(e) => handleChange('responsavel_tecnico', e.target.value)}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};
